/**
 * Static-translations for es. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const es = {
  'anon.description_default': 'Configurando tu sesión de invitado…',
  'anon.heading_default': 'Continuar como invitado',
  'anon.try_again': 'Intentar de nuevo',
  'auth.back_to_login': 'Volver al inicio de sesión',
  'auth.check_email_message': 'Revisa tu correo electrónico para el código de confirmación.',
  'auth.check_email_title': 'Revisa tu correo',
  'auth.confirm_email_subtitle': 'Ingresa el código que enviamos a tu correo para terminar de crear tu cuenta.',
  'auth.confirm_email_title': 'Confirma tu correo',
  'auth.confirmation_code': 'Código de confirmación',
  'auth.continue_with_apple': 'Continuar con Apple',
  'auth.continue_with_facebook': 'Continuar con Facebook',
  'auth.continue_with_github': 'Continuar con GitHub',
  'auth.continue_with_google': 'Continuar con Google',
  'auth.create_account': 'Crear cuenta',
  'auth.default_subtitle': 'Inicie sesión para acceder a todas las funciones y sincronizar sus datos.',
  'auth.email': 'Correo electrónico',
  'auth.email_already_registered': 'Este correo ya está registrado. Inicia sesión abajo con tu contraseña o la cuenta que usaste para registrarte.',
  'auth.email_exists': 'Ya existe una cuenta con este correo.',
  'auth.email_not_confirmed': 'Por favor, confirma tu correo primero.',
  'auth.forgot_password': '¿Olvidó su contraseña?',
  'auth.forgot_password_title': '¿Olvidó su contraseña?',
  'auth.forgot_subtitle': 'Ingrese su correo electrónico y le enviaremos un enlace para restablecer la contraseña.',
  'auth.generic_error': 'Algo salió mal',
  'auth.have_account': '¿Tiene una cuenta?',
  'auth.hide_password': 'Ocultar contraseña',
  'auth.identity_already_linked': 'Esta cuenta ya está registrada. Inicia sesión con ella abajo.',
  'auth.invalid_credentials': 'Correo o contraseña incorrectos',
  'auth.invalid_otp': 'El código no es válido o ha expirado.',
  'auth.last_used': 'Última vez · {email}',
  'auth.last_used_no_email': 'Última vez',
  'auth.link_purchase_subheading': 'Vincularemos la compra a tu cuenta para conservar el acceso.',
  'auth.log_in': 'Iniciar Sesión',
  'auth.log_in_link': 'Iniciar Sesión',
  'auth.login_continue_purchase': 'Inicie sesión para continuar con su compra',
  'auth.network_error': 'Error de red. Comprueba tu conexión y vuelve a intentarlo.',
  'auth.new_password_optional': 'Nueva contraseña (opcional — solo para restablecer)',
  'auth.no_account': '¿No tiene una cuenta?',
  'auth.or': 'o',
  'auth.password': 'Contraseña',
  'auth.passwords_mismatch': 'Las contraseñas no coinciden',
  'auth.rate_limited': 'Demasiadas solicitudes. Inténtalo más tarde.',
  'auth.repeat_password': 'Repetir contraseña',
  'auth.reset_link_valid': 'El enlace es válido durante 1 hora.',
  'auth.reset_password_subtitle': 'Ingresa el código de tu correo y una nueva contraseña.',
  'auth.reset_password_title': 'Restablecer contraseña',
  'auth.reset_sent_message': 'Si ese correo existe, hemos enviado un código de restablecimiento.',
  'auth.reset_sent_subtitle': 'Te enviamos un enlace para restablecer tu contraseña. Sigue las instrucciones del correo.',
  'auth.restore_purchases_heading': 'Restaurar Compras',
  'auth.restore_purchases_subheading': 'Por favor, inicie sesión para restaurar sus compras.',
  'auth.send_reset': 'Enviar Correo de Restablecimiento',
  'auth.service_unavailable': 'Servicio no disponible temporalmente. Inténtalo más tarde.',
  'auth.show_password': 'Mostrar contraseña',
  'auth.sign_out': 'Cerrar sesión',
  'auth.sign_up': 'Registrarse',
  'auth.sign_up_link': 'Registrarse',
  'auth.signed_in': 'Sesión iniciada',
  'auth.signin_failed': 'Error al iniciar sesión',
  'auth.signup_failed': 'Error al registrarse',
  'auth.verify': 'Verificar',
  'auth.weak_password': 'La contraseña es demasiado débil.',
  'auth.welcome': '¡Bienvenido!',
  'auth.welcome_signup': '¡Bienvenido!',
  'cta.close': 'Cerrar',
  'cta.continue': 'Continuar',
  'cta.get_lifetime_access': 'Obtener acceso de por vida',
  'cta.get_plan_daily': 'Obtener plan diario',
  'cta.get_plan_generic': 'Obtener plan {interval}',
  'cta.get_plan_monthly': 'Obtener plan mensual',
  'cta.get_plan_weekly': 'Obtener plan semanal',
  'cta.get_plan_yearly': 'Obtener plan anual',
  'cta.start_trial': 'Iniciar Prueba Gratuita de {days} Días',
  'modal.close_aria': 'Cerrar',
  'modal.continue': 'Continuar',
  'modal.error_generic': 'Algo salió mal',
  'modal.loading': 'Cargando…',
  'modal.purchase_restored_subtitle': '¡Todo listo — que lo disfrutes!',
  'modal.purchase_restored_title': 'Bienvenido de nuevo',
  'modal.purchase_success_subtitle': '¡Todo listo — que lo disfrutes!',
  'modal.purchase_success_title': 'Pago recibido',
  'modal.verifying_subscription': 'Verificando tu suscripción…',
  'nav.back': '← Atrás',
  'nav.back_aria': 'Volver',
  'offer.limited_time': 'Oferta por tiempo limitado',
  'payment.awaiting_subtitle': 'Detectaremos tu pago automáticamente — o haz clic abajo cuando termines.',
  'payment.awaiting_title': 'Completa el pago en la nueva pestaña',
  'payment.checking': 'Verificando…',
  'payment.ive_paid': 'He pagado',
  'payment.open_checkout_again': 'Abrir pago de nuevo',
  'payment.open_checkout_button': 'Abrir pago',
  'payment.popup_blocked_message': 'Tu navegador bloqueó la pestaña de pago. Haz clic abajo para abrirla.',
  'payment.popup_blocked_title': 'Permite ventanas emergentes para continuar',
  'payment.popup_help_text': '¿La ventana de pago no se abrió o fue bloqueada? Haz clic aquí para abrirla de nuevo.',
  'payment.still_processing': 'El pago todavía se está procesando. Inténtalo de nuevo en un momento.',
  'payment.tab_closed_retry': '¿Pestaña cerrada? Inténtalo de nuevo',
  'pricing.free_trial_days': 'Prueba gratuita de {days} días',
  'pricing.included_per': 'Incluido por {interval}:',
  'pricing.interval.day': 'día',
  'pricing.interval.lifetime_short': 'de por vida',
  'pricing.interval.month': 'mes',
  'pricing.interval.period': 'período',
  'pricing.interval.week': 'semana',
  'pricing.interval.year': 'año',
  'pricing.money_back': 'Garantía de devolución de 30 días',
  'pricing.most_popular': 'Más popular',
  'pricing.no_prices': 'No hay precios disponibles.',
  'pricing.plan_label.daily': 'PLAN DIARIO',
  'pricing.plan_label.lifetime': 'de por vida',
  'pricing.plan_label.monthly': 'plan mensual',
  'pricing.plan_label.weekly': 'plan semanal',
  'pricing.plan_label.yearly': 'plan anual',
  'pricing.plans_aria': 'Planes',
  'session.contact_support': 'Contactar con soporte',
  'session.restore_purchases': 'Restaurar compras',
  'session.sign_out': 'Cerrar sesión',
  'session.signed_in_as_prefix': 'Sesión iniciada como',
  'session.signing_out': 'Cerrando sesión…',
  'support.attachments_aria': 'Subir adjuntos',
  'support.attachments_label': 'Archivos adjuntos',
  'support.close_button': 'Cerrar',
  'support.done_button': 'Listo',
  'support.dropzone_text': 'Suelta imágenes aquí o haz clic para seleccionar',
  'support.email_placeholder': 'Ingrese su correo electrónico',
  'support.file_requirements': 'JPEG/PNG/WebP, hasta {max} archivos, ≤ {size} MB cada uno',
  'support.heading': 'Soporte',
  'support.instruction': 'Por favor, complete el formulario a continuación para enviar su solicitud de soporte.',
  'support.invalid_email': 'Correo electrónico inválido',
  'support.invalid_file': 'Solo JPEG/PNG/WebP, ≤ {size} MB cada uno',
  'support.message_length': '1–5000 caracteres',
  'support.message_placeholder': 'Ingrese su mensaje',
  'support.remove_file_aria': 'Eliminar {filename}',
  'support.required': 'Requerido',
  'support.send_another': 'Enviar otra solicitud',
  'support.send_button': 'Enviar',
  'support.sending': 'Enviando…',
  'support.sending_as': 'Enviando como',
  'support.subject_length': '3–200 caracteres',
  'support.subject_placeholder': 'Ingrese el asunto',
  'support.success_heading': 'Solicitud enviada',
  'support.success_message_prefix': 'Hemos recibido su mensaje y responderemos a',
  'support.too_many_files': 'Hasta {max} archivos'
} as const;

export default es;
